<template>
  <div>
    <Loader v-if="loading"/>

    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <ConclusionDiagnoses
      :diagnoses="diagnoses"
      :establishments="diagnosisEstablishments"
      :userCanAdd="userCanAdd"
      :userCanEdit="userCanEdit"
      :submitDiagnosisEstablishment="submitDiagnosisEstablishment"/>

    <ConclusionFunctionals
      :functionals="functionals"
      :establishments="functionalEstablishments"
      :userCanAdd="userCanAdd"
      :userCanEdit="userCanEdit"
      :submitFunctionalEstablishment="submitFunctionalEstablishment"/>

    <ConclusionAnamnesis
      :anamneses="anamneses"
      :userCanAdd="userCanAdd"
      :userCanEdit="userCanEdit"
      :submitAnamnesis="submitAnamnesis"/>

    <ConclusionConclusions
      :conclusions="conclusions"
      :userCanAdd="userCanAdd"
      :userCanEdit="userCanEdit"
      :submitConclusion="submitConclusion"/>
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import ConclusionConclusions from './conclusion/Conclusions';
import ConclusionDiagnoses from './conclusion/Diagnoses';
import ConclusionFunctionals from './conclusion/Functionals';
import ConclusionAnamnesis from './conclusion/Anamnesis';

export default {
  name: 'ClientConclusion',

  components: {
    Loader,
    Flash,
    ConclusionConclusions,
    ConclusionDiagnoses,
    ConclusionFunctionals,
    ConclusionAnamnesis,
  },

  props: ['client'],

  data() {
    return {
      loading: true,
      error: '',
      success: '',
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    conclusions() {
      return this.$store.getters.clientConclusions(this.client.id);
    },

    diagnoses() {
      return this.$store.state.diagnoses;
    },

    diagnosisEstablishments() {
      return this.$store.getters.clientDiagnosisEstablishments(this.client.id);
    },

    functionals() {
      return this.$store.state.functionals;
    },

    functionalEstablishments() {
      return this.$store.getters.clientFunctionalEstablishments(this.client.id);
    },

    anamneses() {
      return this.$store.getters.clientAnamneses(this.client.id);
    },

    userCanAdd() {
      return this.$security.voters.conclusion.canAdd(this.$store.state.user);
    },

    userCanEdit() {
      return this.$security.voters.conclusion.canEdit(this.$store.state.user);
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('LOAD_CONCLUSIONS', this.client.id),
          this.$store.dispatch('LOAD_DIAGNOSES'),
          this.$store.dispatch('LOAD_DIAGNOSIS_ESTABLISHMENTS', this.client.id),
          this.$store.dispatch('LOAD_FUNCTIONALS'),
          this.$store.dispatch('LOAD_FUNCTIONAL_ESTABLISHMENTS', this.client.id),
          this.$store.dispatch('LOAD_ANAMNESES', this.client.id),
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitConclusion(data) {
      this.loading = true;

      try {
        const { id, text, note, dateFrom } = data;
        const params = {
          id,
          client: this.client.id,
          text,
          note,
          dateFrom: new Date(dateFrom),
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_CONCLUSION', params);

          this.success = 'Заключение успешно обновлено';
        } else {
          await this.$store.dispatch('ADD_CONCLUSION', params);

          this.success = 'Заключение успешно добавлено';
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitDiagnosisEstablishment(data) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      try {
        const { id, diagnosis, note, dateFrom , dateTo } = data;
        const params = {
          id,
          client: this.client.id,
          diagnosis,
          note,
          dateFrom: new Date(dateFrom),
          dateTo: dateTo ? new Date(dateTo) : '',
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_DIAGNOSIS_ESTABLISHMENT', params);

          this.success = 'Диагноз успешно обновлен';
        } else {
          await this.$store.dispatch('ADD_DIAGNOSIS_ESTABLISHMENT', params);

          this.success = 'Диагноз успешно добавлен';
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitFunctionalEstablishment(data) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      try {
        const { id, functional, note, dateFrom , dateTo } = data;
        const params = {
          id,
          client: this.client.id,
          functional,
          note,
          dateFrom: new Date(dateFrom),
          dateTo: dateTo ? new Date(dateTo) : '',
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_FUNCTIONAL_ESTABLISHMENT', params);

          this.success = 'Функциональное состояние успешно обновлено';
        } else {
          await this.$store.dispatch('ADD_FUNCTIONAL_ESTABLISHMENT', params);

          this.success = 'Функциональное состояние успешно добавлено';
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    async submitAnamnesis(data) {
      this.loading = true;

      try {
        const { id, text, date } = data;
        const params = {
          id,
          user: this.client.id,
          text,
          date: new Date(date),
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_ANAMNESIS', params);

          this.success = 'Анамнез успешно обновлен';
        } else {
          await this.$store.dispatch('ADD_ANAMNESIS', params);

          this.success = 'Анамнез успешно добавлен';
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
